import React, { useState } from "react";
import "../styles/PlacementGuidance.css";
import BookDemo from "../components/BookDemo"; // ✅ import modal

export default function PlacementTraining() {
  const [showDemo, setShowDemo] = useState(false); // ✅ popup state

  return (
    <div className="placement-page">
      
      {/* ================= HERO ================= */}
      <section className="placement-hero" />

      {/* ================= OVERVIEW ================= */}
      <section className="placement-section">
        <h2>Placement Training</h2>
        <p className="section-desc">
          Sprout Knowledge Solutions provides structured, industry-aligned
          placement training to help pre-final & final year and final year students
          confidently crack campus and off-campus placements.
        </p>

        <h2>Why Placement Training at Sprout?</h2>
        <p className="section-desc">
          As students enter their pre-final & final year, placement preparation
          becomes critical. Our placement training program is designed to bridge
          the gap between academic knowledge and real-world industry
          expectations, ensuring students are job-ready before graduation.
        </p>

        <div className="feature-grid">
          <div className="feature-card">
            <h3>Campus & Off-Campus Focus</h3>
            <p>
              Dedicated training for campus drives, pooled placements, and
              off-campus hiring processes.
            </p>
          </div>

          <div className="feature-card">
            <h3>Industry-Aligned Curriculum</h3>
            <p>
              Training modules designed based on current hiring patterns and
              company expectations.
            </p>
          </div>

          <div className="feature-card">
            <h3>Placement Confidence</h3>
            <p>
              Build confidence to face HR, technical rounds, group discussions,
              and managerial interviews.
            </p>
          </div>
        </div>
      </section>

      {/* ================= TRAINING AREAS ================= */}
      <section className="placement-section light">
        <h2>What We Train You On</h2>

        <div className="guidance-grid">
          <div className="guidance-item">
            <h4>Resume & Portfolio Building</h4>
            <ul>
              <li>ATS-friendly resumes for freshers</li>
              <li>Project-based portfolios for recruiters</li>
              <li>LinkedIn, GitHub & profile optimization</li>
            </ul>
          </div>

          <div className="guidance-item">
            <h4>Interview Preparation</h4>
            <ul>
              <li>HR & technical interview training</li>
              <li>Mock interviews with feedback</li>
              <li>Company-specific interview questions</li>
            </ul>
          </div>

          <div className="guidance-item">
            <h4>Aptitude, Logic & Coding</h4>
            <ul>
              <li>Quantitative aptitude & reasoning</li>
              <li>Problem-solving & coding assessments</li>
              <li>Placement test strategies</li>
            </ul>
          </div>

          <div className="guidance-item">
            <h4>Soft Skills & Professional Readiness</h4>
            <ul>
              <li>Communication & presentation skills</li>
              <li>Group discussions & teamwork</li>
              <li>Corporate etiquette & workplace readiness</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= PLACEMENT SUPPORT ================= */}
      <section className="placement-section">
        <h2>Placement Support at Sprout</h2>

        <div className="support-grid">
          <div className="support-card">
            <h3>Internships & Live Projects</h3>
            <p>
              Internship guidance, real-time projects, and hands-on exposure to
              strengthen student resumes.
            </p>
          </div>

          <div className="support-card">
            <h3>Job Opportunities & Guidance</h3>
            <p>
              Support with job alerts, hiring partners, referrals, and placement
              opportunities.
            </p>
          </div>

          <div className="support-card">
            <h3>1:1 Career Mentorship</h3>
            <p>
              Personalized mentoring sessions to guide students toward the
              right career path.
            </p>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="placement-cta">
        <h2>Get Placement-Ready with Sprout Knowledge Solutions</h2>
        <p>
          Start your placement preparation early and step into your final year
          with confidence.
        </p>

        {/* ✅ POPUP — NO ROUTING */}
        <button
          className="cta-btn"
          onClick={() => setShowDemo(true)}
        >
          Join Placement Training
        </button>
      </section>

      {/* ================= DEMO POPUP ================= */}
      {showDemo && (
        <BookDemo onClose={() => setShowDemo(false)} />
      )}
    </div>
  );
}
